import { useAsync, useGetQuery } from '../../../lib/client/hooks';

import * as services from '../services';
import * as TYPES from '../constants';
import { useDataSettings } from '.';
import { useEffect } from 'react';
import shallow from 'zustand/shallow';

export function useSettingList(params) {
  const { data, status, errorMessage, isIdle, refetch, isFetching } =
    useGetQuery({
      queryKey: TYPES.FETCH_ANNOUNCEMENT,
      queryFn: async () => {
        const response = await services.listDataSettings(params);
        return response.data;
      },
    });

  return {
    data,
    status,
    errorMessage,
    isIdle,
    refetch,
    isFetching,
  };
}

export function useUpdateList() {
  const { execute, status, value, errorMessage, fieldErrors } = useAsync(
    services.updateDataSettings,
  );
  const [setResult] = useDataSettings((state) => [state.setResult], shallow);

  useEffect(() => {
    if (status === 'resolved') {
      setResult(value.data);
    }
  }, [status]);

  async function update(payload) {
    try {
      await execute(payload);
    } catch (err) {
      console.error(err);
    }
  }
  return [update, status, errorMessage, fieldErrors];
}
